<template>
  <v-card flat class="main-card">
    <v-card-text v-if="windowWidth <= 960" class="card-padding">
      <v-flex md6 xs12>
        <v-layout row wrap>
          <v-flex md4 xs12 class="row-title">Total exchange commission:</v-flex>
          <v-flex md8 xs12 class="row-value">
            {{ sellOrder.base_currency }}
            {{ sellOrder.total_commission_paid.toFixed(8) }}
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md4 xs12 class="row-title">GSMG commission:</v-flex>
          <v-flex
            v-if="sellOrder.quantity !== sellOrder.surplus_quantity_total"
            md8
            xs12
            class="row-value"
          >
            ETH
            <span :title="sellOrder.gsmg_fee_gwei + ' GWEI'">
              {{ sellOrder.gsmg_fee_gwei / 1e9 }}
            </span>
          </v-flex>
          <v-flex v-else md8 xs12 class="row-value">{{
            $t("not_applicable")
          }}</v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
    <v-card-text class="card-padding">
      <p class="title mt-1">Sell order</p>
      <v-layout row wrap>
        <v-flex md6 xs12 row>
          <v-layout row wrap>
            <v-flex md4 xs12 class="row-title">Order ID:</v-flex>
            <v-flex md8 xs12 class="row-value">
              {{ sellOrder.uuid }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4 xs12 class="row-title">Price:</v-flex>
            <v-flex md8 xs12 class="row-value">
              {{ sellOrder.base_currency }} {{ sellOrder.price.toFixed(8) }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4 xs12 class="row-title">Quote quantity:</v-flex>
            <v-flex md8 xs12 class="row-value">
              {{ sellOrder.base_currency }}
              {{ (sellOrder.quantity * sellOrder.price) | roundNumber(8) }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4 xs12 class="row-title">Exchange commission:</v-flex>
            <v-flex md8 xs12 class="row-value">
              {{ sellOrder.base_currency }}
              {{ sellOrder.sell_commission_paid.toFixed(8) }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4 xs12 class="row-title">Surplus qty:</v-flex>
            <v-flex md8 xs12 class="row-value">
              {{ sellOrder.target_currency }}
              {{
                sellOrder.surplus_quantity_total
                  ? sellOrder.surplus_quantity_total.toString().substring(0, 8)
                  : 0
              }}
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="windowWidth > 960" md6 xs12>
          <v-layout row wrap>
            <v-flex md4 xs12 class="row-title"
              >Total exchange commission:</v-flex
            >
            <v-flex md8 xs12 class="row-value">
              {{ sellOrder.base_currency }}
              {{ sellOrder.total_commission_paid.toFixed(8) }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4 xs12 class="row-title">GSMG commission:</v-flex>
            <v-flex
              v-if="sellOrder.quantity !== sellOrder.surplus_quantity_total"
              md8
              xs12
              class="row-value"
            >
              ETH
              <span :title="sellOrder.gsmg_fee_gwei + ' GWEI'">
                {{ sellOrder.gsmg_fee_gwei / 1e9 }}
              </span>
            </v-flex>
            <v-flex v-else md8 xs12 class="row-value">{{
              $t("not_applicable")
            }}</v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text class="card-padding mb-3">
      <p class="title">Buy orders ({{ buyOrders.length }})</p>
      <v-data-table
        :headers="buyOrderHeaders"
        :items="buyOrders || []"
        :disable-initial-sort="true"
        :item-key="uuid"
        :pagination.sync="pagination"
        class="buy-orders-table"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable text-xs-left',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : ''
              ]"
              :aria-sort="pagination.descending ? 'descending' : 'ascending'"
              @click="changeSort(header)"
            >
              {{ header.text }}
              <v-icon small>arrow_upward</v-icon>
              <v-icon
                v-if="header.text == 'Order ID'"
                class="vertical-align-middle icon-for-information"
                style="font-size: 16px; opacity: 1; color: rgba(0,0,0,.54); transform: none !important; -webkit-transform: none !important;"
                @click.stop.prevent
                @click="
                  () => {
                    infoAlert(
                      $t('information.trade_history_buy_orders_id.title'),
                      $t('information.trade_history_buy_orders_id.description')
                    );
                  }
                "
              >
                fa-info-circle
              </v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td>
            {{ props.item.ts_opened_utc | formatDate("DD MMM YYYY HH:mm") }}
          </td>
          <td>
            {{ props.item.ts_closed_utc | formatDate("DD MMM YYYY HH:mm") }}
          </td>
          <td>{{ props.item.price.toFixed(8) }}</td>
          <td>{{ props.item.quantity.toFixed(8) }}</td>
          <td>
            {{ baseCurrency }} {{ props.item.commission_paid.toFixed(8) }}
          </td>
          <td>{{ props.item.uuid }}</td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import swal from "sweetalert2";
import {mapGetters} from "vuex";

const timezone = moment()
  .tz(moment.tz.guess())
  .format("z");

export default {
  props: {
    baseCurrency: null,
    sellOrder: {},
    uuid: null
  },
  data: function() {
    return {
      windowWidth: window.innerWidth,
      buyOrders: [],
      buyOrderHeaders: [
        { text: `Opened (${timezone})`, value: "ts_opened_utc" },
        { text: `Closed (${timezone})`, value: "ts_closed_utc" },
        { text: "Price", value: "price" },
        { text: "Quantity", value: "quantity" },
        { text: "Commission paid", value: "commission_paid" },
        { text: "Order ID", value: "uuid" }
      ],
      pagination: {
        descending: false,
        sortBy: null
      }
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    })
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  created: async function() {
    axios.get("/api/v1/trade/details/" + this.sellOrder.uuid).then(res => {
      this.buyOrders = res.data;
    });
  },
  methods: {
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    changeSort: function(header) {
      this.pagination.sortBy = header.value;
      this.pagination.descending = !this.pagination.descending;
    }
  }
};
</script>

<style scoped>
.theme--light .v-card__text {
  color: #103a84;
}

.theme--light .main-card {
  border: 1px solid #d1e2ff;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 16px;
  margin-bottom: 16px;
  box-shadow: none !important;
}

.theme--dark .main-card {
  border: 1px solid #454547;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 16px;
  margin-bottom: 16px;
  box-shadow: none !important;
}

.theme--light .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
}

.theme--dark .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
}

.theme--light .row-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}

.theme--dark .row-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}

.theme--light .row-value {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
}

.theme--dark .row-value {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #e9e9e9;
}

.theme--light.v-datatable table tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
}

.theme--dark.v-datatable table tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #e9e9e9;
}

.card-padding {
  padding: 32px 32px 0px 32px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/dashboard/TradeDetails.vue